import React from 'react';
import { FileTextIcon, UsersIcon, StarIcon, HeartIcon } from 'lucide-react';
export function SocialProof() {
  return <section className="bg-white border-b border-gray-200 pb-12" data-id="element-207">
      <div className="bg-green-50 border-y border-green-100 py-3 mb-10" data-id="element-208">
        <div className="max-w-4xl mx-auto px-4 flex items-center justify-center space-x-3" data-id="element-209">
          <div className="flex -space-x-2" data-id="element-210">
            {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-gray-300 border-2 border-white overflow-hidden" data-id="element-211">
                <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="Avatar" className="w-full h-full object-cover" data-id="element-212" />
              </div>)}
          </div>
          <p className="text-green-800 font-medium text-sm md:text-base" data-id="element-213">
            ✅ Già scelto da <span className="font-bold" data-id="element-214">2.847+</span>{' '}
            insegnanti in tutta Italia
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4" data-id="element-215">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-id="element-216">
          <div className="flex flex-col items-center text-center p-4 rounded-2xl bg-amber-50" data-id="element-217">
            <FileTextIcon className="w-8 h-8 text-amber-600 mb-2" data-id="element-218" />
            <span className="text-2xl font-bold text-stone-900" data-id="element-219">300+</span>
            <span className="text-sm text-stone-600" data-id="element-220">Risorse digitali</span>
          </div>

          <div className="flex flex-col items-center text-center p-4 rounded-2xl bg-red-50" data-id="element-221">
            <UsersIcon className="w-8 h-8 text-red-600 mb-2" data-id="element-222" />
            <span className="text-2xl font-bold text-stone-900" data-id="element-223">2.8k+</span>
            <span className="text-sm text-stone-600" data-id="element-224">Insegnanti attivi</span>
          </div>

          <div className="flex flex-col items-center text-center p-4 rounded-2xl bg-yellow-50" data-id="element-225">
            <StarIcon className="w-8 h-8 text-yellow-500 mb-2 fill-current" data-id="element-226" />
            <span className="text-2xl font-bold text-stone-900" data-id="element-227">4.9/5</span>
            <span className="text-sm text-stone-600" data-id="element-228">Valutazione media</span>
          </div>

          <div className="flex flex-col items-center text-center p-4 rounded-2xl bg-rose-50" data-id="element-229">
            <HeartIcon className="w-8 h-8 text-rose-500 mb-2 fill-current" data-id="element-230" />
            <span className="text-2xl font-bold text-stone-900" data-id="element-231">100%</span>
            <span className="text-sm text-stone-600" data-id="element-232">Soddisfazione</span>
          </div>
        </div>
      </div>
    </section>;
}